"use strict";
export const application = `/api/v1/applications`;
export const definition = `/api/v1/definitions`;
export const addons = `/api/v1/addons`;
export const enabledAddon = `/api/v1/enabled_addon`;
export const addonRegistries = `/api/v1/addon_registries`;
export const cluster = "/api/v1/clusters";
export const project = `/api/v1/projects`;
export const targetURL = `/api/v1/targets`;
export const envURL = `/api/v1/envs`;
export const payloadTypeURL = `/api/v1/payload_types`;
export const repository = "/api/v1/repository";
export const authenticationLogin = `/api/v1/auth/login`;
export const authenticationDexConfig = `/api/v1/auth/dex_config`;
export const authenticationSystemInfo = `/api/v1/system_info`;
export const authenticationLoginType = `/api/v1/auth/login_type`;
export const authenticationRefreshToken = `/api/v1/auth/refresh_token`;
export const authenticationUserInfo = `/api/v1/auth/user_info`;
export const authenticationAdminConfigured = `/api/v1/auth/admin_configured`;
export const authenticationInitAdmin = `/api/v1/auth/init_admin`;
export const users = `/api/v1/users`;
export const roles = `/api/v1/roles`;
export const platformPermissions = `/api/v1/permissions`;
export const configs = `/api/v1/configs`;
export const configTemplates = `/api/v1/config_templates`;
export const cloudShell = `/api/v1/cloudshell`;
export const plugin = `/api/v1/plugins`;
export const managePlugin = `/api/v1/manage/plugins`;
